import { useTranslate } from "@similarweb/i18n-provider";

import { useToasts } from "app/common/hooks";
import { useApiMutation } from "app/modules/api-client";

import { GaConnectTexts } from "../texts";

import { useInvalidateRelatedGaMappingQueries } from "./useInvalidateRelatedGaMappingQueries";

interface IUseActivationGaMappingMutationParams {
    activationId: string;
    hasGaMapping?: boolean;
}

export const useActivationGaMappingMutation = ({
    activationId,
    hasGaMapping,
}: IUseActivationGaMappingMutationParams) => {
    const { showSuccessToast, showErrorToast } = useToasts();
    const { translate } = useTranslate();
    const invalidateRelatedGaMappingQueries = useInvalidateRelatedGaMappingQueries(activationId);

    return useApiMutation("Activation", hasGaMapping ? "activationGaMappingUpdate" : "activationGaMappingCreate", {
        onSuccess: async ({ analyticsAccountName, state }) => {
            await invalidateRelatedGaMappingQueries();

            if (state === "Disabled") {
                showSuccessToast(translate(GaConnectTexts.gaSettingsConnectionDisabledToast, { analyticsAccountName }));
            }
        },
        onError: (error) => {
            showErrorToast(translate("common.api.error", { error: error.problem?.detail ?? error.message }));
        },
    });
};
